import { render } from "./GenericUpload.vue?vue&type=template&id=88dd9ed6&scoped=true&ts=true"
import script from "./GenericUpload.vue?vue&type=script&lang=ts"
export * from "./GenericUpload.vue?vue&type=script&lang=ts"

import "./GenericUpload.vue?vue&type=style&index=0&id=88dd9ed6&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88dd9ed6"]])

export default __exports__